import { useEffect, useState } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import { IconButton, Grid, Box, Modal, Card, CardContent } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import BTC from "../../Img/btc.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import consts from "../../constant";
import usercalls from "../../Axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const Botdashboard = () => {
  const navigate = useNavigate();
  const path = usercalls();
  const { state } = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const [tradeEntities, setTradeEntities] = useState({});
  const getTradeEntites = async () => {
    try {
      if (!state?.id) return;
      const url = `${consts.BackendUrl}/bots/get-trade-entities`;
      const payload = { id: state.id };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setTradeEntities(result?.result);
      } else {
        setTradeEntities({});
      }
    } catch (error) {
      setTradeEntities({});
    }
  };
  const getAccountDetails = async () => {
    try {
      if (!state?.id) return;
      const url = `${consts.BackendUrl}/bots/get-account-details`;
      const payload = { id: state.id };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setAccountDetails(result?.result);
      } else {
        setAccountDetails({});
      }
    } catch (error) {
      setAccountDetails({});
    }
  };
  useEffect(() => {
    if (!state?.id) return;
    getAccountDetails();
    getTradeEntites();
  }, [state?.id]);
  useEffect(() => {
    if (!state?.id) {
      navigate("/bot");
    }
  }, [state?.id, navigate]);
  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="bot_dash contain-width">
            <div
              className="display-1 mt-20 mb-20 bot-width"
              style={{ justifyContent: "space-between" }}
            >
              <div className="display-2 ">
                <div>
                  <Stack direction="row" spacing={2}>
                    <Avatar
                      alt={accountDetails?.name || "User"}
                      src={accountDetails?.market_icon || BTC}
                      imgProps={{
                        onError: (e) => {
                          try {
                            e.currentTarget.src = BTC;
                          } catch (err) {}
                        },
                      }}
                      style={{ width: "60px", height: "60px" }}
                    >
                      {accountDetails?.exchange_name
                        ? accountDetails.exchange_name.charAt(0).toUpperCase()
                        : "E"}
                    </Avatar>
                  </Stack>
                </div>
                <div>
                  <div className="display-1 ">
                    <div>UserName:</div>
                    <div>{accountDetails?.name || "-"}</div>
                  </div>
                  <div className="display-1 ">
                    <div>Exchange:</div>
                    <div>{accountDetails?.exchange_name || "-"}</div>
                  </div>
                </div>
              </div>

              {/* <div className="bot_comman_btn">
                <Button>Edit</Button>
              </div> */}
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>USDT Balance</h3>
              <div>
                {isNaN(accountDetails?.usd_amount)
                  ? "0.00000"
                  : Number(accountDetails?.usd_amount)?.toFixed(5)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>BTC Balance</h3>
              <div>
                {isNaN(accountDetails?.btc_amount)
                  ? "0.00000"
                  : Number(accountDetails?.btc_amount)?.toFixed(8)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Total USD Profit</h3>
              <div
                style={{
                  color:
                    Number(accountDetails?.total_usd_profit) >= 0
                      ? "#00C853"
                      : "#FF5252",
                }}
              >
                {isNaN(accountDetails?.total_usd_profit)
                  ? "0.00"
                  : Number(accountDetails?.total_usd_profit)?.toFixed(5)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Day Profit (USD)</h3>
              <div
                style={{
                  color:
                    Number(accountDetails?.day_profit_usd) >= 0
                      ? "#00C853"
                      : "#FF5252",
                }}
              >
                {isNaN(accountDetails?.day_profit_usd)
                  ? "0.00"
                  : Number(accountDetails?.day_profit_usd)?.toFixed(5)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Profit %</h3>
              <div
                style={{
                  color:
                    Number(accountDetails?.usd_profit_percentage) >= 0
                      ? "#00C853"
                      : "#FF5252",
                }}
              >
                {isNaN(accountDetails?.usd_profit_percentage)
                  ? "0.00%"
                  : `${Number(accountDetails?.usd_profit_percentage)?.toFixed(2)}%`}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Market Type</h3>
              <div>{accountDetails?.pretty_display_type || "-"}</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Active Bot</h3>
              <div>{tradeEntities?.active_bots_count || 0}</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Active Deals</h3>
              <div>{tradeEntities?.active_deals_count || 0}</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Smart Trade Count</h3>
              <div>{tradeEntities?.active_smart_trades_count || 0}</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Active Grid Bots</h3>
              <div>{tradeEntities?.active_grid_bots_count || 0}</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>Order Counts</h3>
              <div>{tradeEntities?.active_orders_count || 0}</div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <div className="bot_container p-1 mt-20">
            <div className="display-2 ">
              <h3>API Key Status</h3>
              <div
                style={{
                  color:
                    accountDetails?.api_keys_state === "ok"
                      ? "#00C853"
                      : "#FF5252",
                }}
              >
                {accountDetails?.api_keys_state
                  ? accountDetails.api_keys_state.toUpperCase()
                  : "-"}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
          <div
            className="bot_dash p-2"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 className="">Simple Trade</h3>

            <div className="bot_comman_btn green-btn">
              <Button
                onClick={() =>
                  navigate("/simpletrade", {
                    state: {
                      id: state?.id,
                      account_id: accountDetails.id,
                      market_code: accountDetails.market_code,
                      exchange_name: accountDetails?.exchange_name,
                    },
                  })
                }
              >
                Open
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
          <div
            className="bot_dash p-2"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 className="">DCA Bot</h3>

            <div className="bot_comman_btn green-btn">
              <Button
                onClick={() =>
                  navigate("/dcabot", {
                    state: {
                      id: state?.id,
                      account_id: accountDetails.id,
                      market_code: accountDetails.market_code,
                      exchange_name: accountDetails?.exchange_name,
                    },
                  })
                }
              >
                Open
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
          <div
            className="bot_dash p-2"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 className="">Grid Bot</h3>

            <div className="bot_comman_btn green-btn">
              <Button
                onClick={() =>
                  navigate("/gridbot", {
                    state: {
                      id: state?.id,
                      account_id: accountDetails.id,
                      market_code: accountDetails.market_code,
                      exchange_name: accountDetails?.exchange_name,
                    },
                  })
                }
              >
                Grid Bot
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
          <div
            className="bot_dash p-2"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 className="">Smart Trade</h3>

            <div className="bot_comman_btn green-btn">
              <Button
                onClick={() =>
                  navigate("/smarttrade", {
                    state: {
                      id: state?.id,
                      account_id: accountDetails.id,
                      market_code: accountDetails.market_code,
                      exchange_name: accountDetails?.exchange_name,
                    },
                  })
                }
              >
                Open
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* <Grid spacing={2} container>
                <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                    <div className="bot_dash">
                        <div className="">
                            Simple Trade
                        </div>

                        <div className="bot_comman_btn green-btn">
                            <Button
                            >
                                Verify
                            </Button>
                        </div>

                    </div>

                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>

                </Grid>
            </Grid> */}
    </div>
  );
};

export default Botdashboard;
